import React from "react";
import { Box, LinearProgress } from "@mui/material";

const Loader = () => (
  <Box sx={{ width: "100%" }}>
    <LinearProgress color="info" sx={{ height: "6px" }} />
  </Box>
);

export default Loader;
